import { isToday } from 'date-fns/isToday';
import React, { useMemo } from 'react';

import { usePaymentAccountContext } from '../../../../hooks/useAccountState';
import useTranslation from '../../../../hooks/useTranslation';
import requireMultipleApprovers from '../../../../utils/boolean/requireMultipleApprovers';
import useFormContext from '../../../transaction/Payment/form/useFormContext';

type Props = {
    isOutbox?: boolean;
};

export default ({ isOutbox = false }: Props) => {
    const translated = useTranslation();
    const { state } = useFormContext();
    const { targetFromAccount } = usePaymentAccountContext();
    const multipleApprovers = requireMultipleApprovers(targetFromAccount);
    const text = useMemo(() => {
        if (multipleApprovers) {
            return { sign: translated.signAndAddApproval, outbox: translated.addPaymentForApproval };
        }
        const signMessage =
            state.paymentDate && isToday(state.paymentDate) ? translated.payNow : translated.payWithBankId;
        return { sign: signMessage, outbox: translated.addPaymentForApproval };
    }, [multipleApprovers, translated, state]);
    return <>{isOutbox ? text.outbox : text.sign}</>;
};
